import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/buttonFocus.css';
import './setupAxios'; // must be before App — registers the Keycloak token interceptor
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);